// components/container.jsx
import React from 'react';

function Container({ children, className }) {
  return (
    <div className={className ? `container ${className}` : 'container'}>
      {children}
    </div>
  );
}

export default Container;
